import { Card, Col, Divider, Row, Space, Typography } from "antd"
import { List } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import { parse } from 'papaparse';

import csv_4 from './data/view_1/view1_week_country.csv';
// import { Link } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';


import { useDispatch, useSelector } from 'react-redux';
import { setLoadStatus } from './redux/data_view1';

const Homepage = (props) => {

    const dispatch = useDispatch();
    const loadStatus = useSelector((state) => state.data_view1.dataState.loadStatus);

    // const [getDataState, setGetDataState] = useState(false);
    // const [latestMonth, setLastestMonth] = useState(null);
    // const [latestWeek, setLastestWeek] = useState(null);
    // const [latestYear, setLastestYear] = useState(null);
    
    const scrollWithOffset = (el,loadStatus,view) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        // const yOffset = -100; 
        var yOffset;
        if(loadStatus === false){
            if(view === 2){
                yOffset = 100; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 3){
                yOffset = 300; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 4){
                yOffset = 500; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 5){
                yOffset = 2000; 
                window.scrollTo({ top: yCoordinate }); 
            }
            dispatch(setLoadStatus(true));
        } else {
            yOffset = -100; 
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
        }
        // window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
    }

    // useEffect(() => {
    //     const abortCont = new AbortController();

    //     function streamResolve(url) {
    //         return fetch(url, {mode: 'cors', signal: abortCont.signal }).then(response => response.body)
    //         .then(rb => {
    //             const reader = rb.getReader();
              
    //             return new ReadableStream({
    //               start(controller) {
    //                 // The following function handles each data chunk
    //                 function push() {
    //                   // "done" is a Boolean and value a "Uint8Array"
    //                   reader.read().then( ({done, value}) => {
    //                     // If there is no more data to read
    //                     if (done) {
    //                       console.log('homepage done', done);
    //                       controller.close();
    //                       return;
    //                     }
    //                     // Get the data and send it to the browser via the controller
    //                     controller.enqueue(value);
    //                     // Check chunks by logging to the console
    //                     //console.log(done, value);
    //                     push();
    //                   })
    //                 }
              
    //                 push();
    //               }
    //             });
    //           })
    //           .then(stream => {
    //             // Respond with our stream
    //             return new Response(stream, { headers: { "Content-Type": "application/json" } });
    //           })
    //           .then(result => {
    //             // Do things with result
    //             return result;
    //           });
    
    //       }

    //     Promise.all([
    //         streamResolve(csv_4).then(resp => resp.text()),
    //     ])
    //         .then(data => {
    //             const jsonData = [];
    //             data.forEach((d,i) => {
    //                 let d_parse = parse(d,{header: true, dynamicTyping: true, skipEmptyLines:true});
    //                 jsonData.push(d_parse.data);
    //             })
    //             const lastestData = jsonData[0][jsonData[0].length-1];
    //             setLastestMonth(lastestData.DMON);
    //             setLastestWeek(lastestData.DWEEK);
    //             setLastestYear(lastestData.DYEAR);
    //             setGetDataState(true);
    //         }).catch(err => {
    //             if(err.name === 'AbortError'){
    //                 console.log('fetch aborted');
    //             }
    //         });
    // }, []);

    // console.log(getDataState,latestMonth,latestWeek,latestYear);

    return ( 
        <div className="align-right">
            <Row>
                <Col span={24}>
                    {/* {getDataState && <p>ข้อมูลอัพเดทล่าสุด สัปดาห์ที่ {latestWeek} เดือน {latestMonth} ปี {latestYear}</p>} */}
                    {/* <br/> */}
                    <Card style={{ width: 300, backgroundColor: '#517a38', borderRadius: '15px'}}>
                    < Space direction="vertical">
                        <Link to="/graphs&map#" scroll={el => scrollWithOffset(el,loadStatus,1) } className='linkGraph'>
                            การตายส่วนเกินตามเวลา
                        </Link>
                        <hr/>
                        <Link to="/graphs&map#graph2" scroll={el => scrollWithOffset(el,loadStatus,2)} className='linkGraph'>
                            การเปรียบเทียบจำนวนตายในช่วงปีที่มีการระบาดของโรคโควิด-19 และ จำนวนตายที่คาดประมาณ
                        </Link>
                        <hr/>
                        <Link to="/graphs&map#graph3" scroll={el => scrollWithOffset(el,loadStatus,3)} className='linkGraph'>
                            การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ
                        </Link>
                        <hr/>
                        {/* <a href="/view3">
                            กราฟที่ 3 - การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ
                        </a> */}
                        <Link to="/graphs&map#graph4" scroll={el => scrollWithOffset(el,loadStatus,4)} className='linkGraph'>
                            การตายส่วนเกินจำแนกตามสาเหตุการตาย และ สถานที่เสียชีวิต
                        </Link>
                        <hr/>
                        <Link to="/graphs&map#graph5" scroll={el => scrollWithOffset(el,loadStatus,5)} className='linkGraph'>
                            แผนที่การตายส่วนเกิน
                        </Link>
                    </Space>
                    </Card>
                </Col>
            </Row>
        </div>
     );
}
 
export default Homepage;